/** @jsxImportSource @emotion/react */

import { ModalTypeValue } from "enums/modalType";
import { currency } from "helpers/formatCurrency";
import { useAppDispatch } from "hooks/app-hook";
import { isMobile } from "router";
import { setOpenModal } from "store/master";

import { TableLvUpStyle } from "./style.index";

type Props = {
  current_turnover: string;
  level: number;
  turnover: string;
  turnover_percentage: string;
  deposit: string;
  current_deposit: string;
};

const TableLvUp = ({
  current_turnover,
  level,
  turnover,
  current_deposit,
  deposit,
}: Props) => {
  const dispatch = useAppDispatch();

  const handleOpenModal = () => {
    if (!isMobile) {
      dispatch(setOpenModal(ModalTypeValue.VIP));
      return;
    }
    dispatch(setOpenModal(ModalTypeValue.MOBILE_VIP));
  };

  const depositFormat = Number(deposit.replace(/\.00$/, ""));
  const currentDepositFormat = Number(current_deposit.replace(/\.00$/, ""));
  const percentDepositFormat = (currentDepositFormat / depositFormat) * 100;

  const turnoverFormat = Number(turnover.replace(/\.00$/, ""));
  const currentTurnOverFormat = Number(current_turnover.replace(/\.00$/, ""));
  const percentTurnOverFormat = (currentTurnOverFormat / turnoverFormat) * 100;

  return (
    <div css={TableLvUpStyle.wrapper}>
      <div css={TableLvUpStyle.levelUpHeader}>
        <p>VIP {level} Điều kiện nâng cấp</p>
        <div css={TableLvUpStyle.btnLevelUp} onClick={() => handleOpenModal()}>
          Ngưỡng nâng cấp
        </div>
      </div>
      <div css={TableLvUpStyle.levelUpContent}>
        <div css={TableLvUpStyle.point}>
          <p>Điểm</p>
          <div css={TableLvUpStyle.textStatus}>
            <div css={TableLvUpStyle.textPoint}>
              <span>{currency(currentTurnOverFormat)}</span> /{" "}
              {currency(turnoverFormat)}
            </div>
            <span>
              Thiếu : {currency(turnoverFormat - currentTurnOverFormat)}
            </span>
          </div>
          <div css={TableLvUpStyle.progressTurnover(percentTurnOverFormat)} />
          <span>Ngưỡng nâng cấp : {currency(turnoverFormat)}</span>
        </div>
        <div css={TableLvUpStyle.point}>
          <p>Tích luỹ tiền gửi</p>
          <div css={TableLvUpStyle.textStatus}>
            <div css={TableLvUpStyle.textPoint}>
              <span>{currency(currentDepositFormat)}</span> /{" "}
              {currency(depositFormat)}
            </div>
            <span>
              Thiếu : {currency(depositFormat - currentDepositFormat)}
            </span>
          </div>
          <div css={TableLvUpStyle.progressDeposit(percentDepositFormat)} />
        </div>
      </div>
    </div>
  );
};

export default TableLvUp;
